<div class="bottom-sheet">
    <div>
        <button mat-icon-button (click)="onCancel()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
        <h2 mat-dialog-title>Send Email</h2>
    </div>

    <mat-stepper [linear]="true" #stepper>

        <mat-step [completed]="emailFormGroup.valid" [stepControl]="emailFormGroup">
            <form [formGroup]="emailFormGroup" class="mt-4">
                <ng-template matStepLabel>Draft</ng-template>

                <div class="row">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="application.Co_Appl_Required === 'Yes'">
                        <mat-label>Applicant</mat-label>
                        <mat-select formControlName="applicant">
                            <mat-option value="MAIN">Main applicant</mat-option>
                            <mat-option value="CO">Co applicant</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Sender</mat-label>
                        <mat-select formControlName="senderEmail">
                            <mat-option *ngFor="let emailSender of emailSenders" [value]="emailSender.email">
                                {{emailSender.email}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Recipient</mat-label>
                        <input formControlName="recipientEmail" matInput type="email"
                            placeholder="customer@example.com">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email Template</mat-label>
                        <mat-select formControlName="templateId">
                            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">
                                {{template.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Subject</mat-label>
                        <input formControlName="subject" matInput placeholder="Email subject">
                    </mat-form-field>

                    <div class="row w-100" *ngIf="availableOptions.length > 0">
                        <mat-label>Options</mat-label>
                        <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
                            (change)="toggleSelectAll()" color="primary">
                            <label>
                                {{ isAllSelected() ? 'Deselect All' : 'Select All' }}
                            </label>
                        </mat-checkbox>
                        <mat-selection-list formControlName="selectedOptions" multiple>
                            <mat-list-option *ngFor="let option of availableOptions" [value]="option.id"
                                togglePosition="before" color="primary">
                                <div>
                                    <div>{{option.label}}</div>
                                    <div *ngIf="option.description">
                                        {{option.description}}
                                    </div>
                                </div>
                            </mat-list-option>
                        </mat-selection-list>
                    </div>
                </div>

                <div>
                    <button mat-button (click)="onCancel()" type="button">
                        Cancel
                    </button>
                    <button mat-raised-button color="primary" matStepperNext (click)="onPreview()"
                            [disabled]="emailFormGroup.invalid" type="button">
                        Preview
                    </button>
                </div>
            </form>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Preview</ng-template>

            <div class="row">
                <mat-card>
                    <mat-card-content>
                        <div class="row">
                            <label>Recipient: {{ emailFormGroup.controls.recipientName.value }}
                                ({{ Applicant.toDisplayText(emailFormGroup.controls.applicant.value) }})</label>
                            <label>Subject: {{ emailFormGroup.controls.subject.value }}</label>
                            <label>Template: {{selectedTemplate?.name}}</label>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-4">
                    <mat-card-content>
                        <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(emailFormGroup.controls.content.value)"></div>
                    </mat-card-content>
                </mat-card>

                <div class="mt-4">
                    <button mat-button matStepperPrevious type="button">
                        Back
                    </button>
                    <button mat-raised-button color="primary" (click)="onSend()" type="button">
                        <mat-icon>send</mat-icon>
                        Send Email
                    </button>
                </div>
            </div>
        </mat-step>
    </mat-stepper>
</div>
